import { Button, Checkbox } from "@material-ui/core";
import { useEffect, useState } from "react";
import adminService from "../../Services/adminService";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Swal from "sweetalert2";
import AddNewProductStatePopup from "../../NestedComponents/widgets/addNewProductStatePopup";

const AdminProductStates = () => {
  const [productStates, setProductStates] = useState([]);
  const [isAddNewPopupOpen, setIsAddNewPopupOpen] = useState(false);
  const [newProductStateInfo, setNewProductStateInfo] = useState({});
  const [formatErrors, setFormatErrors] = useState({});

  useEffect(() => {
    async function getClientProductStatuses() {
      const res = await adminService.getAllProductStates();
      setProductStates(res);
    }
    getClientProductStatuses();
  }, []);

  return (
    <div className="width100 flex mt-50 justify-center">
      <div className="admin-product-states-con">
        <Button className="align-self-lg-start" color="primary" variant="contained" onClick={() => setIsAddNewPopupOpen(true)}>
          Add New State
        </Button>
        <div className="flex justify-between border-bottom mt-20 bold">
          <div className="width20 mr-10">State Hebrew</div>
          <div className="width20">State English</div>
          <div className="">Btax</div>
          <div className="ml-10">Courses</div>
        </div>
        <div className="admin-product-states-details nice-scroller">
          {productStates?.map((state, i) => {
            return (
              <div className="flex justify-between" key={state.stateHeb}>
                <div className="flex align-items-center width20">
                  <DeleteForeverIcon className="pointer yellow-color" onClick={() => handleDeleteState(i, state.stateName)} />
                  <div className="mr-10">{state.stateHeb}</div>
                </div>
                <div className="flex left width20 align-items-center">{state.stateName}</div>
                <Checkbox
                  className="yellow-color"
                  checked={state.usedInProducts?.length ? state.usedInProducts.includes("btax") : false}
                  onChange={() => handleCheckboxChange("btax", i, state.stateName)}
                />
                <Checkbox
                  color="primary"
                  checked={state.usedInProducts?.length ? state.usedInProducts.includes("courses") : false}
                  onChange={() => handleCheckboxChange("courses", i, state.stateName)}
                />
              </div>
            );
          })}
        </div>
      </div>
      {isAddNewPopupOpen && (
        <AddNewProductStatePopup
          isAddNewPopupOpen={isAddNewPopupOpen}
          handleAdd={handleAddNewState}
          handleClose={handleCloseAddNewPopup}
          onChange={productStateOnChange}
          newProductStateInfo={newProductStateInfo}
          formatErrors={formatErrors}
        />
      )}
    </div>
  );

  async function handleAddNewState() {
    if (productStateValidator()) return;
    const copyProductStates = [...productStates];
    const copyNewProductStateInfo = { ...newProductStateInfo };
    const foundState = copyProductStates.find(
      (state) => state.stateHeb === newProductStateInfo.stateHeb || state.stateName === newProductStateInfo.stateName
    );
    if (foundState) return Swal.fire("State with this name already exists", "", "error");
    const res = await adminService.addNewProductState(newProductStateInfo);
    if (res.success) {
      copyNewProductStateInfo._id = res.addedStateId;
      copyProductStates.push(copyNewProductStateInfo);
      setProductStates(copyProductStates);
      setIsAddNewPopupOpen(false);
      setNewProductStateInfo({});
      setFormatErrors({});
    }
  }

  async function handleCheckboxChange(type, index, stateName) {
    const copyProductStates = [...productStates];
    if (copyProductStates[index].usedInProducts.includes(type)) {
      const res = await adminService.deleteProductStateType(type, copyProductStates[index]._id, stateName);
      if (res.thereAreUsers) return Swal.fire("There are users with this state", "", "error");
      copyProductStates[index].usedInProducts = copyProductStates[index].usedInProducts.filter((product) => product !== type);
    } else {
      await adminService.editProductStateType(type, copyProductStates[index]._id);
      copyProductStates[index].usedInProducts.push(type);
    }
    setProductStates(copyProductStates);
  }

  async function handleDeleteState(index, stateName) {
    const copyProductStates = [...productStates];
    const result = await Swal.fire({
      title: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    });
    if (result.isConfirmed) {
      const res = await adminService.deleteProductState(copyProductStates[index]._id, stateName);
      if (res.success) {
        if (res.thereAreUsers) return Swal.fire("There are users with this state", "", "error");
        copyProductStates.splice(index, 1);
        setProductStates(copyProductStates);
      }
    } else return;
  }

  function handleCloseAddNewPopup() {
    setNewProductStateInfo({});
    setIsAddNewPopupOpen(false);
    setFormatErrors({});
  }

  function productStateValidator() {
    const requiredFields = ["stateHeb", "stateName", "usedInProducts"];
    const copyNewProductStateInfo = { ...newProductStateInfo };
    const copyFormatErrors = { ...formatErrors };
    for (let field of requiredFields) {
      if (field === "usedInProducts" && Array.isArray(copyNewProductStateInfo[field]) && !copyNewProductStateInfo[field].length)
        copyFormatErrors[field] = "This field is required";
      if (!copyNewProductStateInfo[field]) copyFormatErrors[field] = "This field is required";
    }
    setFormatErrors(copyFormatErrors);

    if (Object.keys(copyFormatErrors).length) {
      return true;
    } else return false;
  }

  function productStateOnChange(field, value) {
    const copyFormatErrors = { ...formatErrors };
    if (copyFormatErrors[field]) delete copyFormatErrors[field];
    setNewProductStateInfo({ ...newProductStateInfo, [field]: value });
    setFormatErrors(copyFormatErrors);
  }
};

export default AdminProductStates;
